import type { DomainSpecificConfig } from '../types';

const config: DomainSpecificConfig = {
  domains: [/127\.0\.0\.1:.*/, /student.localhost.*/],
  domainType: 'student',
};

export default config;
